import Swiper, { Manipulation } from "swiper";
import { initIntersectionObserver } from "@plugins";

const reviews = document.querySelector(".js-reviews");

if (window.mobileMedia && reviews) {
    initIntersectionObserver(reviews, initReviewsSlider);
}

function initReviewsSlider(slider) {
    const swiperContainer = slider.querySelector(".swiper");

    if (swiperContainer) {
        const swiper = new Swiper(swiperContainer, {
            modules: [Manipulation],
            slidesPerView: 1.2,
            spaceBetween: 16,
        });

        const allReviewsLink = slider.querySelector(".js-all-reviews-link");

        if (allReviewsLink) {
            allReviewsLink.classList.add("swiper-slide");
            swiper.appendSlide(allReviewsLink);
        }
    }
}
